import React, {useEffect, useState} from 'react';
import {useAppDispatch, useAppSelector} from "../../lib/hooks";
import {useHistory} from "react-router";
import {ProprietarioObject} from "../../models/Proprietario";
import {FazendaObject} from "../../models/Fazenda";
import {actions} from "../../lib/app";
import {filtrarColecao} from "../../lib/utils";
import {EntityList} from "../../components/EntityListNG";
import {useFazendasProprietario} from "../../lib/DataHooks/fazendas";
import FormFazenda from "../Fazendas/FormFazenda/FormFazenda";
import {fazendaCardContent, fazendaCardTitle, fazendaCardSubtitle} from "../Fazendas/FazendaCard";

interface AbaFazendasProps {
  instance: ProprietarioObject;
}

const AbaFazendas: React.FC<AbaFazendasProps> = (props) => {
  const {instance} = props;
  const user = useAppSelector(state => state.app.user);
  const history = useHistory();
  const dispatch = useAppDispatch();
  const [colecaoFiltrada, setColecaoFiltrada] = useState<ProprietarioObject[]>([]);

  const [colecao, loading] = useFazendasProprietario({
    userId: user.uid, proprietario: instance});

  useEffect(() => {
    if (colecao && !loading) {
      setColecaoFiltrada(filtrarColecao(colecao, '', 'nome'));
    }
  }, [colecao, loading]);

  const _filtrarColecao = (criterio:string='') => {
    setColecaoFiltrada(filtrarColecao(colecao, criterio, 'nome'));
  }

  const onClickInstance = (fazenda: FazendaObject) => {
    dispatch(actions.jump(`/proprietarios/${instance.id}/fazendas`));
    history.push(`/fazendas/${fazenda.id}/home`);
  };

  return (
    <EntityList
      entityLabel="fazenda"
      colecao={colecaoFiltrada}
      loading={loading}
      filtrarColecao={_filtrarColecao}
      addEnabled={false}
      onClickInstance={onClickInstance}
      cardSubTitle={fazendaCardSubtitle}
      cardTitle={fazendaCardTitle}
      cardContent={fazendaCardContent}
      ModelForm={FormFazenda}
    />
  );
}

export default AbaFazendas;
